module.exports = __webpack_public_path__ + "static/media/M008-noprivilege.e6f6acd7.svg";